/**
 * BannerSlot -- one-slot banner coordinator (P1a). At most ONE of the five
 * shell banners renders at a time, priority order:
 *
 *   ConnectionBanner > UpdateBanner > PushBanner > ClosingStrip > AwarenessStrip
 *
 * Each banner keeps its own visibility logic and exports a lightweight
 * `wantsToShow` computed derived from its existing store/state; this slot
 * just renders the highest-priority one that wants to show. Because
 * ClosingStrip and AwarenessStrip previously kicked off their own data
 * loading from mount effects (and are no longer mounted until they have
 * data), BannerSlot triggers those loads on mount instead; both entry
 * points are idempotent.
 */

import { useEffect } from 'preact/hooks';
import { ConnectionBanner, connectionBannerWantsToShow } from './ConnectionBanner';
import { UpdateBanner, updateBannerWantsToShow } from './UpdateBanner';
import { PushBanner, pushBannerWantsToShow } from './PushBanner';
import { ClosingStrip, closingStripWantsToShow, refreshNextClosing } from './ClosingStrip';
import { AwarenessStrip, awarenessStripWantsToShow } from './AwarenessStrip';
import { startAwarenessPolling } from './awareness-store';

export function BannerSlot() {
  useEffect(() => {
    refreshNextClosing();
    startAwarenessPolling();
  }, []);

  if (connectionBannerWantsToShow.value) return <ConnectionBanner />;
  if (updateBannerWantsToShow.value) return <UpdateBanner />;
  if (pushBannerWantsToShow.value) return <PushBanner />;
  if (closingStripWantsToShow.value) return <ClosingStrip />;
  if (awarenessStripWantsToShow.value) return <AwarenessStrip />;
  return null;
}
